import { useNavigate, useParams } from 'react-router-dom';

import { useFetchContratos } from '@/shared/actions/erp';
import { SaveNuevoTicket } from '../../shared/components/SaveNuevoTicket';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { toast } from 'react-toastify';
import { useGetTicketSoporteCliente } from '@/shared/actions/erp/tickets-soporte-cliente';

export interface UpdateNuevoTicketInterface {}

const UpdateNuevoTicket: React.FC<UpdateNuevoTicketInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ticket_soporte)
  const navigate = useNavigate()
  const {idcontrato, idticket} = useParams()
  if (!idcontrato || !idticket) {
    navigate(ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav)
    toast.error('Debe seleccionar un registro para crear un ticket.')
    return null
  }
  const {
    data:contrato,
    isLoading,
  } = useFetchContratos({
    enabled: true,
    params: {
      codigo: idcontrato!,
      todos:true,
    }
  })
  const {
    data: ticketSoporteCliente,
    isLoading: isLoadingTicketSoporteCliente,
  } = useGetTicketSoporteCliente(idticket!)
  useLoaders(isLoading || isLoadingTicketSoporteCliente)
  //|| contrato?.data?.data?.length==0
  if(
    ((!isLoading && !contrato) || (!isLoadingTicketSoporteCliente && !ticketSoporteCliente)) 
    // && (!isLoading || !isLoadingTicketSoporteCliente)
  ){
    navigate(ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav)
    return 
  }
  return <SaveNuevoTicket titlePage="Revisar Ticket de Soporte" editTicketSoporte={ticketSoporteCliente?.data as any}  contrato={(contrato?.data as any)?.data?.[0]} />;
};

export default UpdateNuevoTicket;
